import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
import envs from '@/envs'
import NotFound from '@/views/common/NotFound.vue'
// import { isTouchOneLogin } from '@/utils/check'
import Login from '@/layout/components/nLogin'
import Logout from '@/layout/components/Logout'
import MyPage from '@/layout/components/MyPage'
import Sso from '@/layout/components/Sso'
import Regist from '@/layout/components/Regist'
import FindIdPw from '@/layout/components/FindIdPw'
import RouterSection from '@/layout/components/RouterSection'
import EventHandler from '@/utils/eventHandler'
import { isMobile, getAgent } from '@/utils/check'

import localStore from '@/utils/localStore'
// login 검증을 위함
import { getToken } from '@/utils/token'

// 내부 router들 정의
import managerList from './modules/managerList'
import exampleList from './modules/exampleList'
import masterList from './modules/masterList'
import mobileList from './modules/mobileList'
// 화면 변경 시, 화면 정보 및 log 정보 처리
import logger from '@/utils/log'

Vue.use(Router)

/**
 * name 작성 시 유념 사항
 * 1. name은 고유 값이어야 합니다.
 * 2. router 내 name과 .vue 내부의 name은 동일해야 합니다.
 */

// 모바일로 들어올 경우 홈 위치를 변경
let home = 'login'
let mobileMode = isMobile() && envs.framework.template.useMobile

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: RouterSection,
      redirect: { name: home },
      children: [
        {
          path: 'login',
          name: 'login',
          component: Login,
          // component: () => import('@/views/mobile/nMobileLogin.vue'),
          // component: () => import('@/views/pc/manager/Resource.vue'),
          meta: {
            asideView: false,
            tagView: false,
            headerView: false,
            footerView: false
          }
        },
        {
          path: 'logout',
          name: 'logout',
          component: Logout,
          meta: { asideView: false, tagView: false }
        },
        {
          path: 'Sso',
          name: 'Sso',
          component: Sso,
          meta: {
            asideView: false,
            tagView: false,
            headerView: true,
            footerView: true
          }
        },
        {
          path: 'phoneCertificate',
          name: 'phoneCertificate',
          component: () => import('@/layout/components/PhoneCertificate.vue'),
          meta: { asideView: false, tagView: false }
        },
        // {
        //   path: 'privacyInfo',
        //   name: 'privacyInfo',
        //   props: true,
        //   component: () => import('@/views/pc/PrivacyInfo.vue'),
        //   meta: { asideView: false, tagView: false }
        // },
        // {
        //   path: 'VideoInformationPolicy',
        //   name: 'VideoInformationPolicy',
        //   props: true,
        //   component: () => import('@/views/pc/VideoInformationPolicy.vue'),
        //   meta: { asideView: false, tagView: false }
        // },
        {
          path: 'siteWork',
          name: 'siteWork',
          props: true,
          component: () => import('@/views/pc/site/SiteWork.vue'),
          meta: {
            headerView: true,
            footerView: true,
            asideView: false,
            tagView: false
          }
        },
        {
          path: 'ess/siteWork',
          name: 'essSiteWork',
          props: true,
          component: () => import('@/views/pc/siteEss/SiteWork.vue'),
          meta: {
            headerView: true,
            footerView: true,
            asideView: false,
            tagView: false
          }
        },
        {
          path: 'cctvPopup',
          name: 'cctvPopup',
          component: () => import('@/views/pc/site/CctvPopup.vue'),
          meta: {
            asideView: false,
            tagView: false,
            headerView: false,
            footerView: false
          }
        },
        {
          path: 'mypage',
          name: 'mypage',
          component: MyPage,
          meta: {
            asideView: false
          }
        },
        {
          path: 'regist',
          name: 'regist',
          component: Regist,
          meta: { asideView: false, tagView: false }
        },
        {
          path: 'findidpw',
          name: 'FindIdPw',
          component: FindIdPw,
          meta: { asideView: false, tagView: false }
        },
        {
          path: 'blank',
          name: 'blank',
          component: () => import('@/views/Blank.vue')
        },
        {
          path: 'monitoring',
          name: 'monitoring'
        },
        {
          path: 'centeras',
          name: 'CenterAS',
          component: () => import('@/views/monitoring/CenterAS.vue'),
          meta: {
            asideView: false,
            tagView: false,
            headerView: true
          }
        },
        {
          path: 'personalmonitoring',
          name: 'PersonalMonitoring',
          component: () => import('@/views/monitoring/PersonalMonitoring.vue'),
          meta: {
            asideView: false,
            tagView: false,
            headerView: true
          }
        },
        {
          path: 'constructor',
          name: 'Constructor',
          component: () => import('@/views/monitoring/Constructor.vue'),
          meta: {
            asideView: false,
            tagView: false,
            headerView: true
          }
        },
        {
          path: 'notice',
          name: 'Notice',
          component: () => import('@/views/pc/manager/nNotice.vue'),
          meta: {
            asideView: false
          }
        },
        {
          path: 'resource',
          name: 'Resource',
          component: () => import('@/views/pc/manager/Resource.vue'),
          meta: {
            asideView: false
          }
        },
        {
          path: 'bill',
          name: 'Bill',
          component: () => import('@/views/pc/manager/Bill.vue'),
          meta: {
            asideView: false
          }
        },
        {
          path: 'sendTest',
          name: 'SendTest',
          component: () => import('@/views/master/sendTest.vue'),
          meta: {
            asideView: false
          }
        }
      ]
    },
    exampleList,
    managerList,
    masterList,
    mobileList,
    {
      path: 'not-found',
      name: 'NotFound',
      component: NotFound,
      meta: {
        asideView: false
      }
    },
    { path: '*', component: NotFound, meta: { asideView: false } }
  ]
})

// grp_auth 기반 모니터링 화면 라우팅 (Vuex state 값만 사용)
function doMonitoringRedirect (grpCd, next, mobileMode) {
  if (
    grpCd === 'usergroup002' ||
    grpCd === 'usergroup008' ||
    grpCd === 'usergroup007' ||
    grpCd === 'usergroup006'
  ) {
    if (mobileMode) { next('/mobile/constructor'); return }
    next('/constructor')
  } else if (
    grpCd === 'usergroup001' ||
    grpCd === 'usergroup003' ||
    grpCd === 'usergroup004'
  ) {
    if (mobileMode) { next('/mobile/centeras'); return }
    next('/centeras')
  } else {
    if (mobileMode) {
      if (store.state.user.site_cnt === 1) {
        const siteId = store.state.user.site_id
        next(siteId.indexOf('E') > -1
          ? '/mobile/ess/siteWork?site_id=' + siteId
          : '/mobile/siteWork?site_id=' + siteId)
      } else {
        next('/mobile/personalmonitoring')
      }
      return
    }
    if (store.state.user.site_cnt === 1) {
      const siteId = store.state.user.site_id
      next(siteId.indexOf('E') > -1
        ? '/ess/siteWork?site_id=' + siteId
        : '/siteWork?site_id=' + siteId)
    } else {
      next('/personalmonitoring')
    }
  }
}

// url을 변경할 때 마다 실행되는 interceptor
// 인증 관련 interceptor는 src/auth.js에서 정의한다.
router.beforeEach((to, from, next) => {
  let params = {}
  window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(
    str,
    key,
    value
  ) {
    params[key] = value
  })
  let loginWhiteList = [...envs.framework.whiteList]
  const isWhiteList = loginWhiteList.some(path => {
    return path === to.path
  })

  if (mobileMode && to.path === '/login') {
    next('/mobile/login')
    return
  }

  if (to.path === '/monitoring') {
    // grp_auth는 반드시 Vuex state(서버 세션값)만 참조 - sessionStorage 폴백 사용 금지
    // sessionStorage 조작으로 권한 우회 가능하므로 클라이언트 저장소에서 읽지 않음
    const grpCd = store.state.user.grp_auth || ''

    if (!grpCd && getToken()) {
      // 페이지 새로고침으로 Vuex가 초기화된 경우 - 서버에서 사용자 정보 로드 완료 후 라우팅
      EventHandler.once(() => {
        doMonitoringRedirect(store.state.user.grp_auth || '', next, mobileMode)
      }, 'loaded-permission')
      return
    }

    doMonitoringRedirect(grpCd, next, mobileMode)
    return
  }

  // admin 경로 접근 제어: meta.roles가 정의된 라우트는 grp_auth 검증 필수
  if (to.meta && to.meta.roles) {
    const grpCd = store.state.user.grp_auth || ''
    if (!grpCd && getToken()) {
      // 페이지 새로고침으로 Vuex가 초기화된 경우 - SetUserInfo 완료 후 재판단
      EventHandler.once(() => {
        const g = store.state.user.grp_auth || ''
        if (!to.meta.roles.includes(g)) {
          alert('접근 권한이 없습니다.')
          next('/login')
        } else {
          next()
        }
      }, 'loaded-permission')
      return
    }
    if (!to.meta.roles.includes(grpCd)) {
      alert('접근 권한이 없습니다.')
      next('/login')
      return
    }
  }

  let isMobilePage = envs.framework.mobileList.some(path => {
    return path === to.path
  })
  if (mobileMode && isMobilePage) {
    next('/mobile' + to.path)
  }

  if (mobileMode && to.path === '/siteManage') {
    next('/master/siteManage')
  }

  // 화면 이동 시, 정보를 저장
  // 메뉴 정보 유무를 확인한다. 메뉴 정보가 없을 경우, 이벤트 이후로 실행 시점을 딜레이한다.
  logger.info('Router Change...........')
  if (
    getToken() &&
    params.theme !== 'page' &&
    store.state.menu.menus.length === 0 &&
    !isWhiteList
  ) {
    EventHandler.once(() => {
      logger.start('Router changeView, Menu Loaded :', to)
      logger.changeView(to)
      after()
    }, 'loaded-menu')
  } else {
    logger.changeView(to)
    after()
  }
  function after() {
    // 세션 적용 되면 이곳 로직 변경
    if (!isWhiteList) {
      if (to.query.id) {
        console.log('단독 페이지호출시 next(/login)되던것을 막음')
      } else {
        if (!getToken() && to.path !== '/blank' && to.path !== '/not-found') {
          next('/login')
          return
        }
      }
    }
    // 각 메뉴 이동하는 곳에 따라 좌/우측 메뉴와 태그 뷰 출력을 재정의한다.
    if (to.meta.asideView === undefined) {
      store.dispatch(
        'SetNavigationDrawer',
        store.state.menu.flag.navigationDrawer !== false
      )
    } else {
      store.dispatch('SetNavigationDrawer', to.meta.asideView !== false)
    }
    if (to.meta.headerView === undefined) {
      store.dispatch('SetHeaderUse', store.state.menu.flag.headerUse !== false)
    } else {
      store.dispatch('SetHeaderUse', to.meta.headerView !== false)
    }
    // if (to.meta.footerView === undefined) {
    //   store.dispatch('SetFooterUse', store.state.menu.flag.footerUse !== false)
    // } else {
    store.dispatch('SetFooterUse', to.meta.footerView !== false)
    // }
    store.dispatch('SetTagViewUse', to.meta.tagView !== false)
    next()
  }
})

router.afterEach(() => {
  window.addEventListener('load', function () {
    window.applicationCache.addEventListener('updateready', function () {
      if (window.applicationCache.status == window.applicationCache.UPDATEREADY) {
        window.applicationCache.swapCache()
        window.location.reload()
      }
    }, false)
  }, false)
})

export default router
